<form
  #form="ngForm"
  novalidate
  class="flex flex-col gap-1"
>
  <nsp-calendar-input
    id="etd"
    name="etd"
    label="ETD"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('etd')"
    [readonly]="isFieldReadOnly('etd')"
    [value]="operationalStore.portOperationsTimestamp?.()?.etd?.value"
    [ngModel]="operationalStore.portOperationsTimestamp?.()?.etd?.value"
    [min]="operationalStore.reportDetails?.()?.reportTo?.value"
  />
  <nsp-calendar-input
    id="norTendered"
    name="norTendered"
    label="NOR Tendered"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('norTendered')"
    [readonly]="isFieldReadOnly('norTendered')"
    [value]="operationalStore.portOperationsTimestamp?.()?.norTendered?.value"
    [ngModel]="operationalStore.portOperationsTimestamp?.()?.norTendered?.value"
  />
  <nsp-calendar-input
    id="allFast"
    name="allFast"
    label="All Fast"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('allFast')"
    [readonly]="isFieldReadOnly('allFast')"
    [value]="operationalStore.portOperationsTimestamp?.()?.allFast?.value"
    [ngModel]="operationalStore.portOperationsTimestamp?.()?.allFast?.value"
  />
  <nsp-calendar-input
    id="hosesConnected"
    name="hosesConnected"
    label="Hoses Connected"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('hosesConnected')"
    [readonly]="isFieldReadOnly('hosesConnected')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.hosesConnected?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.hosesConnected?.value
    "
  />
  <nsp-calendar-input
    id="commenceLoad"
    name="commenceLoad"
    label="Commence Load"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('commenceLoad')"
    [readonly]="isFieldReadOnly('commenceLoad')"
    [value]="operationalStore.portOperationsTimestamp?.()?.commenceLoad?.value"
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.commenceLoad?.value
    "
  />
  <nsp-calendar-input
    id="finishLoad"
    name="finishLoad"
    label="Finish Load"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('finishLoad')"
    [readonly]="isFieldReadOnly('finishLoad')"
    [value]="operationalStore.portOperationsTimestamp?.()?.finishLoad?.value"
    [ngModel]="operationalStore.portOperationsTimestamp?.()?.finishLoad?.value"
  />
  <nsp-calendar-input
    id="hosesDisconnected"
    name="hosesDisconnected"
    label="Hoses Disconnected"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('hosesDisconnected')"
    [readonly]="isFieldReadOnly('hosesDisconnected')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.hosesDisconnected?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.hosesDisconnected?.value
    "
  />
  <nsp-calendar-input
    id="lastLine"
    name="lastLine"
    label="Last Line"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('lastLine')"
    [readonly]="isFieldReadOnly('lastLine')"
    [value]="operationalStore.portOperationsTimestamp?.()?.lastLine?.value"
    [ngModel]="operationalStore.portOperationsTimestamp?.()?.lastLine?.value"
  />
  <nsp-calendar-input
    id="cargoDocsOnboard"
    name="cargoDocsOnboard"
    label="Cargo Docs Onboard"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('cargoDocsOnboard')"
    [readonly]="isFieldReadOnly('cargoDocsOnboard')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.cargoDocsOnboard?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.cargoDocsOnboard?.value
    "
  />
  <nsp-calendar-input
    id="startDischarging"
    name="startDischarging"
    label="Start Discharging"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('startDischarging')"
    [readonly]="isFieldReadOnly('startDischarging')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.startDischarging?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.startDischarging?.value
    "
  />
  <nsp-calendar-input
    id="endDischarging"
    name="endDischarging"
    label="End Discharging"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('endDischarging')"
    [readonly]="isFieldReadOnly('endDischarging')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.endDischarging?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.endDischarging?.value
    "
  />
  <nsp-calendar-input
    id="completedTankInspection"
    name="completedTankInspection"
    label="Completed Tank Inspection"
    [labelWidthPercentage]="33"
    [required]="isFieldRequired('completedTankInspection')"
    [readonly]="isFieldReadOnly('completedTankInspection')"
    [value]="
      operationalStore.portOperationsTimestamp?.()?.completedTankInspection
        ?.value
    "
    [ngModel]="
      operationalStore.portOperationsTimestamp?.()?.completedTankInspection
        ?.value
    "
  />
</form>
